import { Dialog, DialogContent, DialogDescription, DialogTitle } from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import Text from 'components/Text';
import { cn } from 'lib/utils';
import { fontSizes } from 'appconstants';

interface ConfirmModalProps {
  open: boolean;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  
}

const ConfirmModal = ({
  open,
  title = 'Are you sure?',
  description = 'This action cannot be undone.',
  confirmText = 'Yes',
  cancelText = 'No',
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmModalProps) => {
  return (
    <Dialog open={open} onOpenChange={loading ? null : onCancel}>
      <DialogContent className={cn('max-w-md rounded-xl px-6 py-6 text-center', 'bg-white shadow-xl')}>
        <DialogTitle>
          <Text text={title} className='font-bold' size={fontSizes.h20} />
        </DialogTitle>
        <DialogDescription>
          <Text text={description} className='text-muted-foreground mb-3' size={fontSizes.h14} />
        </DialogDescription>

        <div className='flex gap-4'>
          <Button
            variant='outline'
            className='w-full rounded-lg border-primary text-primary hover:bg-primary/10'
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </Button>

          <Button className={cn('w-full rounded-lg', 'bg-primary hover:bg-primary/90')} loading={loading} onClick={onConfirm}>
            {confirmText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmModal;
